module.exports = __webpack_public_path__ + "static/media/step9.ff8a79aa.png";